import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, Spinner, EmptyState, Select, usePagination, Pagination } from "@/components/UI";
import { History } from "lucide-react";

const ACTION_COLOR = {
  created: "#9CA3AF", approved: "#D1D5DB", weight_changed: "#D1D5DB",
  status_changed: "#E5E7EB", replaced: "#E5E7EB", reassigned: "#06B6D4",
  rejected: "#F43F5E", cancelled: "#64748B", moved_sprint: "#9CA3AF",
};

export default function AuditTrail() {
  const [logs, setLogs] = useState(null);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    const url = filter ? `/audit-logs?action=${filter}` : "/audit-logs";
    api.get(url).then((r) => setLogs(r.data)).catch(() => {});
  }, [filter]);

  const pg = usePagination(logs, 20);

  return (
    <div className="mx-auto max-w-5xl space-y-6" data-testid="audit-page">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight">Audit Trail</h1>
          <p className="text-sm text-slate-400">Riwayat lengkap perubahan task, bobot, approval & status.</p>
        </div>
        <Select className="w-48" value={filter} onChange={(e) => setFilter(e.target.value)} data-testid="audit-filter">
          <option value="">Semua Aksi</option>
          {Object.keys(ACTION_COLOR).map((a) => <option key={a} value={a}>{a.replace("_", " ")}</option>)}
        </Select>
      </div>

      {!logs ? <Spinner /> : logs.length === 0 ? (
        <EmptyState icon={History} title="Belum ada aktivitas" />
      ) : (
        <Card className="p-2">
          <div className="divide-y divide-slate-800">
            {pg.paged.map((l) => (
              <div key={l.id} className="flex items-start gap-3 p-3" data-testid={`audit-row-${l.id}`}>
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: ACTION_COLOR[l.action] || "#64748B" }} />
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-slate-200">
                    <span className="font-semibold capitalize" style={{ color: ACTION_COLOR[l.action] || "#94A3B8" }}>{l.action.replace("_", " ")}</span>
                    {" — "}<span className="text-slate-300">{l.task?.title || "Task"}</span>
                    {l.old_value != null && l.new_value != null && (
                      <span className="font-mono text-xs text-slate-500"> ({l.field}: {l.old_value} → {l.new_value})</span>
                    )}
                  </p>
                  {l.reason && <p className="text-xs italic text-slate-500">"{l.reason}"</p>}
                </div>
                <div className="shrink-0 text-right">
                  <p className="text-xs text-slate-400">{l.actor?.name || "System"}</p>
                  <p className="text-[11px] text-slate-600">{new Date(l.created_at).toLocaleString("id-ID")}</p>
                </div>
              </div>
            ))}
          </div>
          <Pagination page={pg.page} totalPages={pg.totalPages} total={pg.total} perPage={pg.perPage} onChange={pg.setPage} />
        </Card>
      )}
    </div>
  );
}
